
      import { defu } from 'defu'
      const matcher = /* @__PURE__ */ (() => { const $0={},$1={redirect: "/place/**"};; return (m,p)=>{let r=[];if(p.charCodeAt(p.length-1)===47)p=p.slice(0,-1)||"/";if(p==="/_nuxt"){r.unshift({data:$0});}let s=p.split("/"),l=s.length;if(l>1){if(s[1]==="view"){r.unshift({data:$1,params:{"_":s.slice(2).join('/'),}});}}return r;}})()
      export default (path) => defu({}, ...matcher('', path).map(r => r.data).reverse())
      